class Form {
  theme = null;

  constructor(theme) {
    this.theme = theme;
    Form.instance = this;
  }

  static init(theme) {
    Form.instance = null;
    return new Form(theme);
  }

  getRowStyle() {
    return {
      marginLeft: "20px",
      marginTop: "20px",
      display: "flex",
      alignItems: "center",
      gap: 2,
    };
  }

  getLabelStyle() {
    return {
      width: "150px",
      color: this.theme.palette.primary.greyPrimary,
      fontSize: this.theme.typography.customFontSize[2],
      fontWeight: this.theme.typography.customFontWeight[0],
    };
  }

  getTextfieldStyle = (isValid) => ({
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: this.theme.shape.customBorderRadius[1],
      height: "31px",
      backgroundColor: this.theme.palette.primary.white,
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.borderGreyPrimary
          : this.theme.palette.primary.redPrimary,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.mainHover
          : this.theme.palette.primary.redPrimary,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.main
          : this.theme.palette.primary.redPrimary,
      },
    },
  });

  getTableStyle() {
    return {
      marginTop: "10px",
      padding: "10px",
      maxHeight: "400px",
      overflowY: "auto",
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
    };
  }

  getMaskStyle() {
    return {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 10,
      backgroundColor: this.theme.palette.primary.greyPrimary,
      opacity: 0.2,
      borderRadius: 8,
    };
  }

  getInnerViewStyle(zIndex) {
    return {
      position: "absolute",
      top: 0,
      left: 0,
      display: "flex",
      width: "100%",
      height: "auto",
      backgroundColor: this.theme.palette.primary.white,
      boxShadow: this.theme.shadows[5],
      borderRadius: this.theme.shape.customBorderRadius[2],
      zIndex: zIndex.modal + 2,
    };
  }

  getInnerContainerStyle() {
    return {
      padding: "20px",
      width: "100%",
    };
  }

  getAddItemTopContainerStyle() {
    return {
      display: "grid",
      gridTemplateColumns: "200px 300px 150px 150px",
      alignItems: "center",
    };
  }

  getButtonContainerStyle() {
    return {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "20px",
      marginRight: "20px",
    };
  }

  getAddButtonStyle() {
    return {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
      border: `1px solid ${this.theme.palette.primary.main}`,
      borderRadius: "4px",
      padding: "4px 12px",
      minWidth: "120px",
      color: this.theme.palette.primary.main,
    };
  }

  getNumberStyle() {
    return {
      minWidth: "24px",
      height: "20px",
      fontSize: "12px",
      fontWeight: 500,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: this.theme.palette.primary.main,
      color: this.theme.palette.primary.white,
      borderRadius: "15px",
      padding: "0 15px",
      marginLeft: "4px",
    };
  }
}

export default Form;
